var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[(!_vm.isLogin)?_c('div',[_c('core-filter'),_c('core-toolbar'),_c('core-drawer'),_c('core-view')],1):_vm._e(),(_vm.isLogin)?_c('div',[_c('login')],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }